export enum InstrumentAssetModel {
	VisNetHub = "VisNet Hub",
	GridKey = "Grid Key"
}

//Todo: Replace these once we have the modelIds
export enum InstrumentAssetModelIds {
	VisNetHub = 100004,
	GridKey = 100123
}